<!--
   RSTI Facial Rekognition Auth UI
-->

<p>
  Signing you out ...
</p>
